module.exports = __webpack_public_path__ + "img/compimg.1966ec7c.png";